import { render } from "./_CommentPost.vue?vue&type=template&id=93b6e252"
import script from "./_CommentPost.vue?vue&type=script&lang=js"
export * from "./_CommentPost.vue?vue&type=script&lang=js"

import "./_CommentPost.vue?vue&type=style&index=0&id=93b6e252&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__